import * as THREE from "three";

// with r128
// https://stackoverflow.com/questions/71331022/three-js-buffergeometry-blob-code-update-error

// tympanus
// https://tympanus.net/codrops/2021/01/26/twisted-colorful-spheres-with-three-js/

// https://steemit.com/utopian-io/@clayjohn/learning-3d-graphics-with-three-js-or-dynamic-geometry

// à regarder
// https://sbcode.net/threejs/meshmatcapmaterial/



let renderer

var scene = new THREE.Scene();
// var camera = new THREE.PerspectiveCamera( 45, window.innerWidth/window.innerHeight, 0.1, 1000 );
var camera = new THREE.PerspectiveCamera(
  45,
  window.innerWidth / window.innerHeight,
  0.1,
  1000
);
camera.position.z = 5;

// var sphere_geometry = new THREE.SphereGeometry(1, 128, 128);
// var sphere_geometry = new THREE.SphereGeometry(1, 16, 16);
var sphere_geometry = new THREE.SphereGeometry(1.5, 128, 128);
var sphere_geometry2 = new THREE.SphereGeometry(1.5, 128, 128);
var sphere_geometry3 = new THREE.SphereGeometry(1.5, 128, 128);
// var material = new THREE.MeshNormalMaterial();
var material = new THREE.MeshMatcapMaterial();
var material2 = new THREE.MeshMatcapMaterial();
var material3 = new THREE.MeshMatcapMaterial();
// const material = new THREE.MeshPhongMaterial({
//   color: 0x991ad5,
//   shininess: 1000,
// })

let matcapTexture
let matcapTexture2
let matcapTexture3
// matcapTexture3 = new THREE.TextureLoader().load('matcap-textures/matcap-crystal.png') // pas mal
// matcapTexture = new THREE.TextureLoader().load('matcap-textures/matcap-gold.png') 
// matcapTexture = new THREE.TextureLoader().load('matcap-textures/matcap-green-yellow-pink.png')
// matcapTexture = new THREE.TextureLoader().load('matcap-textures/matcap-opal.png') // pas mal
// matcapTexture = new THREE.TextureLoader().load('matcap-textures/matcap-red-light.png')

// matcapTexture = new THREE.TextureLoader().load('textures.com/TexturesCom_Asphalt_Base11_header.jpg') // pas mal
// matcapTexture = new THREE.TextureLoader().load('textures.com/TexturesCom_Asphalt_Base14_header.jpg')
// matcapTexture = new THREE.TextureLoader().load('textures.com/TexturesCom_Ground_ForestMoss01_header.jpg')
// matcapTexture = new THREE.TextureLoader().load('textures.com/TexturesCom_Wall_Plaster4B_header.jpg')
// matcapTexture = new THREE.TextureLoader().load('textures.com/TexturesCom_Pipe_AluminiumCollapsed_header3.jpg')
// matcapTexture = new THREE.TextureLoader().load('textures.com/InkFull0006_1_350.jpg')

// matcapTexture = new THREE.TextureLoader().load('freepik/gradient-grainy-gradient-texture_79603-1642.jpg')
// matcapTexture = new THREE.TextureLoader().load('freepik/1.png')
// matcapTexture = new THREE.TextureLoader().load('freepik/2.png')
// matcapTexture = new THREE.TextureLoader().load('freepik/3.png')
// matcapTexture = new THREE.TextureLoader().load('freepik/4.png')
matcapTexture3 = new THREE.TextureLoader().load('freepik/gradient-points.png')
// matcapTexture = new THREE.TextureLoader().load('freepik/gradient-points-2.png') 
// matcapTexture = new THREE.TextureLoader().load('freepik/rm218batch4-ning-32.jpg') 
// matcapTexture = new THREE.TextureLoader().load('freepik/M_G_2-02.jpg') 
matcapTexture = new THREE.TextureLoader().load('freepik/5.png') // top !
// matcapTexture2 = new THREE.TextureLoader().load('freepik/6.png') // waw !! ce turquoise !! => trouver un rose
// matcapTexture2 = new THREE.TextureLoader().load('freepik/7.png') // good blue !!
matcapTexture3 = new THREE.TextureLoader().load('freepik/8.png')
// matcapTexture = new THREE.TextureLoader().load('freepik/8.png')
// matcapTexture = new THREE.TextureLoader().load('freepik/10.png')
matcapTexture = new THREE.TextureLoader().load('freepik/11.png') // yes  => beau bleu, a retravailler un peu pour choper le bleu avatar copeau
// matcapTexture = new THREE.TextureLoader().load('freepik/12.png') // WAW !!!
// matcapTexture = new THREE.TextureLoader().load('freepik/13.png') 
// matcapTexture = new THREE.TextureLoader().load('freepik/14.png') // yes
// matcapTexture = new THREE.TextureLoader().load('freepik/15.png') // yes
// matcapTexture2 = new THREE.TextureLoader().load('freepik/16.png') // cool aussi
// matcapTexture = new THREE.TextureLoader().load('freepik/17.png') // yes
// matcapTexture2 = new THREE.TextureLoader().load('freepik/5488082.jpg') // yes
// matcapTexture2 = new THREE.TextureLoader().load('freepik/5488082.jpg') // yes
// matcapTexture = new THREE.TextureLoader().load('freepik/v904-nunny-012.jpg') // yes
matcapTexture2 = new THREE.TextureLoader().load('freepik/v904-nunny-022.jpg') // yes
// matcapTexture3 = new THREE.TextureLoader().load('freepik/5479107.jpg') // yes
// matcapTexture3 = new THREE.TextureLoader().load('freepik/18.png') // yes
// matcapTexture3 = new THREE.TextureLoader().load('freepik/19.png') // yes
// matcapTexture3 = new THREE.TextureLoader().load('freepik/20.png') // yes
// matcapTexture3 = new THREE.TextureLoader().load('freepik/21.png') // moui
// matcapTexture = new THREE.TextureLoader().load('freepik/22.png') // moui
// matcapTexture2 = new THREE.TextureLoader().load('freepik/23.png') // moui
// matcapTexture = new THREE.TextureLoader().load('freepik/24.png') // moui ?
// matcapTexture3 = new THREE.TextureLoader().load('freepik/25.png') // yes
// matcapTexture = new THREE.TextureLoader().load('freepik/26.png') // yes
// matcapTexture = new THREE.TextureLoader().load('freepik/27.png') // moui ? => avec un fond noir ?
// matcapTexture = new THREE.TextureLoader().load('freepik/28.png') // bof

// matcapTexture = new THREE.TextureLoader().load('perso/1.jpg') 
// matcapTexture = new THREE.TextureLoader().load('perso/2.jpg') 
// matcapTexture3 = new THREE.TextureLoader().load('perso/3.jpg') // good :), photos de marbres, bleutés
// matcapTexture = new THREE.TextureLoader().load('perso/4.jpg') 
// matcapTexture = new THREE.TextureLoader().load('perso/5.jpg') 
// matcapTexture = new THREE.TextureLoader().load('perso/6.jpg') 
// matcapTexture = new THREE.TextureLoader().load('perso/7.jpg') // ciel vue de la cuisine
// matcapTexture = new THREE.TextureLoader().load('perso/8.jpg') // voiture cramée
// matcapTexture2 = new THREE.TextureLoader().load('perso/damier-noir-et-blanc-1024x1024.png') // voiture cramée
// matcapTexture = new THREE.TextureLoader().load('perso/degrade-psyche-1024x1024.png') // bof...
// matcapTexture = new THREE.TextureLoader().load('perso/gradient-test-1024x1024.png') // mouais...
// matcapTexture2 = new THREE.TextureLoader().load('perso/voiture-crame-1024x1024.png') // mouais...
matcapTexture3 = new THREE.TextureLoader().load('perso/blanc.png') // m


// matcapTexture3 = new THREE.TextureLoader().load('unblast/Gradient-Abstract-Textures-3.jpg') /// cooooooollll 

// matcapTexture = new THREE.TextureLoader().load('unblast/Vibrant-Swirl-Textures-1.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/scifi-textures/1.jpg') 
// matcapTexture2 = new THREE.TextureLoader().load('unblast/scifi-textures/2.jpg') 
// matcapTexture2 = new THREE.TextureLoader().load('unblast/scifi-textures/3.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/scifi-textures/4.jpg') 
// pb avec la transparence pour les 4 suivants
// matcapTexture = new THREE.TextureLoader().load('unblast/textures-vol2/textures-vol2/PNG/Texture1.png') 
// matcapTexture = new THREE.TextureLoader().load('unblast/textures-vol2/textures-vol2/PNG/Texture2.png') 
// matcapTexture = new THREE.TextureLoader().load('unblast/textures-vol2/textures-vol2/PNG/Texture3.png') 
// matcapTexture = new THREE.TextureLoader().load('unblast/textures-vol2/textures-vol2/PNG/Texture4.png') 

// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/1.jpg') // YES !!
// matcapTexture2 = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/1.jpg') // YES !!
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/2.jpg') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/3.jpg') // WAWwww
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/4.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/5.jpg') // orange
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/6.jpg') // red
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/7.jpg') // pink metal ?
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/8.jpg') // orange metal ?
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/9.jpg') // yes, un peu trash ?
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/10.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/11.jpg') // waw.. ?
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/12.jpg') // WAW !!
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/13.jpg') // cool ?
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/14.jpg') // red blue ?
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/15.jpg') // chrome nice
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/16.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/17.jpg') // YEAH !! CHROME !!
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/18.jpg') // YEAH !! CHROME !!
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/19.jpg') // YES
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/20.jpg') // dark green ?
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/21.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/22.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/23.jpg') // red brillant, cool
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/24.jpg') // YEES => tres brillant (bleu)
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/25.jpg') // YES
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/26.jpg') // YES
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/27.jpg') // blue ?
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/28.jpg') // dark cool
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/29.jpg') // YES !!!
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/30.jpg') // yes red
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/31.jpg') // yes ! reine des neige
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/32.jpg') // soft purple
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/33.jpg') // pas mal
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/34.jpg') // magma, cool
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/35.jpg') // yes
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/36.jpg') // pas mal
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/37.jpg') // yes
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/38.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/39.jpg') // pas mal +
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/40.jpg') // pas mal
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/41.jpg') // pas mal
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/42.jpg') // pas mal
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/43.jpg') // yes
// matcapTexture2 = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/44.jpg') // yes
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/45.jpg') // moui ?
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/46.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/47.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/48.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/49.jpg') 
// matcapTexture = new THREE.TextureLoader().load('unblast/50 Free Swirl Textures Pack - FREE/50.jpg') // tripant


// matcapTexture = new THREE.TextureLoader().load('unblast/pexels-harry-cooke-6194972.jpg') // YES, sac poubelle noir !!

// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/1.jpg') // yes
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/5.jpg') // cool, un peu trop foncé
// matcapTexture2 = new THREE.TextureLoader().load('unblast/acrylic/5.jpg') // cool, un peu trop foncé
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/8.jpg') // yes
// matcapTexture2 = new THREE.TextureLoader().load('unblast/acrylic/8.jpg') // yes
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/21.jpg') // yes, intéressant !
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/30.jpg') // idem => tester avec mes mino !!
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/35.jpg') // nice !
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/43.jpg') //
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/46.jpg') // good
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/55.jpg') //
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/58.jpg') // tres beau jaune
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/69.jpg') // tre beau bleu
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/72.jpg') //
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/76.jpg') // rola !
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/79.jpg') // class
// matcapTexture = new THREE.TextureLoader().load('unblast/acrylic/80.jpg') // yes

// matcapTexture = new THREE.TextureLoader().load('unblast/5 Free Peach & Cream Textures - FREE/1.jpg') //
// matcapTexture = new THREE.TextureLoader().load('unblast/5 Free Peach & Cream Textures - FREE/2.jpg') // YES , belle peche
// matcapTexture = new THREE.TextureLoader().load('unblast/5 Free Peach & Cream Textures - FREE/3.jpg') //
// matcapTexture = new THREE.TextureLoader().load('unblast/5 Free Peach & Cream Textures - FREE/4.jpg') //
// matcapTexture = new THREE.TextureLoader().load('unblast/5 Free Peach & Cream Textures - FREE/5.jpg') // yes, peche rose

// matcapTexture = new THREE.TextureLoader().load('unblast/denim/01.jpg') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/denim/02.png') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/denim/03.jpg') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/denim/04.jpg') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/denim/05.jpg') // cool
// matcapTexture2 = new THREE.TextureLoader().load('unblast/denim/06.jpg') // 
// matcapTexture2 = new THREE.TextureLoader().load('unblast/denim/01_NORM.jpg') // 
// matcapTexture2 = new THREE.TextureLoader().load('unblast/denim/02_NORM.jpg') // 
// matcapTexture2 = new THREE.TextureLoader().load('unblast/denim/03_NORM.jpg') // 
// matcapTexture2 = new THREE.TextureLoader().load('unblast/denim/04_NORM.jpg') // 
// matcapTexture2 = new THREE.TextureLoader().load('unblast/denim/05_NORM.jpg') // cool
// matcapTexture2 = new THREE.TextureLoader().load('unblast/denim/06_NORM.jpg') // cool

// @todo => convert tif !
// matcapTexture = new THREE.TextureLoader().load('unblast/Free Worn Textures Pack - FREE/TIFF Textures/worn_.tif') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Free Worn Textures Pack - FREE/TIFF Textures/worn_2.tif') //

// matcapTexture = new THREE.TextureLoader().load('unblast/10 Unique Hand Painted Acrylic Textures - FREE/1.jpg') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/10 Unique Hand Painted Acrylic Textures - FREE/2.jpg') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/10 Unique Hand Painted Acrylic Textures - FREE/3.jpg') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/10 Unique Hand Painted Acrylic Textures - FREE/4.jpg') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/10 Unique Hand Painted Acrylic Textures - FREE/5.jpg') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/10 Unique Hand Painted Acrylic Textures - FREE/6.jpg') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/10 Unique Hand Painted Acrylic Textures - FREE/7.jpg') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/10 Unique Hand Painted Acrylic Textures - FREE/8.jpg') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/10 Unique Hand Painted Acrylic Textures - FREE/9.jpg') // space
// matcapTexture = new THREE.TextureLoader().load('unblast/10 Unique Hand Painted Acrylic Textures - FREE/10.jpg') // peut être pas mal.

// toutes avec alpha...
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/1.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/2.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/3.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/4.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/5.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/6.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/7.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/8.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/9.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/10.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/11.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/12.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/13.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/14.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/15.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/16.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/17.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/18.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/19.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/20.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/21.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/22.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/23.png') // 
// matcapTexture = new THREE.TextureLoader().load('unblast/Grunge Textures png/24.png') //

// girly
// matcapTexture = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/Electric Purple  (16).jpg') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/Hot Pink (32).jpg') // cool
// matcapTexture2 = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/Hot Pink (32).jpg') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/Iris (1).jpg') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/Lavender (5).jpg') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/Lavender (8).jpg') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/Lavender (10).jpg') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/Lavender (11).jpg') // cool => tres etrange, on voit mal le volume
// matcapTexture = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/Purpink (8).jpg') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/tender pink (3).jpg') // cool
// matcapTexture = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/violet  (4).jpg') // cool
// matcapTexture3 = new THREE.TextureLoader().load('unblast/200 Girlicious Texture Bundle - FREE/violet  (4).jpg') // cool


// matcapTexture = new THREE.TextureLoader().load('41NBDpUGZ-S._AC_SX450_.jpg') // test gilet jaune => pas free !! faire un scan perso
// matcapTexture = new THREE.TextureLoader().load('Gilet-Securite-Jaune.jpg') // test gilet jaune => pas free !! faire un scan perso
// matcapTexture = new THREE.TextureLoader().load('10115.png') // test gilet jaune => pas free !! faire un scan perso
// matcapTexture = new THREE.TextureLoader().load('8903321190430.jpg') // good
// matcapTexture2 = new THREE.TextureLoader().load('8903321190430.jpg') // good
// matcapTexture2 = new THREE.TextureLoader().load('gilet-fluo-jaune-de-signalisation-xxl-grande-taill.jpg') // bof
// matcapTexture = new THREE.TextureLoader().load('gilet-jaune-de-securite-auto.jpg') // bof



material.matcap = matcapTexture
material2.matcap = matcapTexture2
material3.matcap = matcapTexture3


var sphere = new THREE.Mesh(sphere_geometry, material);
var sphere2 = new THREE.Mesh(sphere_geometry2, material2);
var sphere3 = new THREE.Mesh(sphere_geometry3, material3);

// const ambientLight = new THREE.AmbientLight(0x798296)
const ambientLight = new THREE.AmbientLight(0x798296)
scene.add(ambientLight)
const directionalLight = new THREE.DirectionalLight(0xff0000, 0.5)
    directionalLight.position.set(5, 10, 7)
scene.add(directionalLight);

sphere.geometry.attributes.position.needsUpdate = true;
sphere2.geometry.attributes.position.needsUpdate = true;
sphere3.geometry.attributes.position.needsUpdate = true;


// const material = new THREE.MeshMatcapMaterial()

console.log('==> THREE.Geometry', THREE.Geometry)
// let geo = new THREE.Geometry();
// var geometry = new THREE.Geometry().fromBufferGeometry( sphere.geometry );


scene.add(sphere);
scene.add(sphere2);
scene.add(sphere3);

// console.log('==> sphere.geometry.vertices', sphere.geometry.vertices)
// console.log('==> sphere.geometry', sphere.geometry)
// console.log('==> sphere_geometry', sphere_geometry)
// console.log(sphere.geometry.isBufferGeometry)

var update = function () {
  // change '0.003' for more aggressive animation
  // var time = performance.now() * 0.0009;
  var time = performance.now() * 0.00054;
  // var time = performance.now() * 0.001;
  //console.log(time)

  //go through vertices here and reposition them

  // change 'k' value for more spikes
  // var k = 1.5;
  
  // var v3 = new THREE.Vector3();  

  var k = 0.99;
  // var k = 1.81;
  // var k = 1.54;
  var v3 = new THREE.Vector3();   
  var p = new THREE.Vector3();   
  const positions = sphere.geometry.attributes.position;
  // for (var i = 0; i < positions.count; i++) {
  //   v3.fromBufferAttribute(positions, i).setLength(k);
  //   let n = noise.perlin3(v3.x, v3.y, v3.z);
  //   v3.setLength(1 + 0.3 * n);
  //   positions.setXYZ(i, v3.x, v3.y, v3.z);
  // }

  for (var i = 0; i < positions.count; i++) {
    // positions.setXYZ(i, v3.x, v3.y, v3.z);
    p.fromBufferAttribute(positions, i) //.setLength(k);
    p.normalize().multiplyScalar(
      1 + 0.3 * noise.perlin3(p.x * k + time, p.y * k, p.z * k)
    )
    positions.setXYZ(i, p.x, p.y, p.z);
  }
  positions.needsUpdate = true;
  sphere.geometry.computeVertexNormals(); // don't forget to call this
  
  
};

var update2 = function () {
  // change '0.003' for more aggressive animation
  // var time = performance.now() * 0.0009;
  var time = performance.now() * 0.00027;
  // var time = performance.now() * 0.001;
  // var time = performance.now() * 0.0009;
  //console.log(time)

  //go through vertices here and reposition them

  // change 'k' value for more spikes
  // var k = 1.5;
  
  // var v3 = new THREE.Vector3();  

  // var k = 1.05;
  var k = 1.54;
  // var k = 1.27;
  // var k = 2.81;
  // var k = 2.81;
  var v3 = new THREE.Vector3();   
  var p = new THREE.Vector3();   
  const positions = sphere2.geometry.attributes.position;
  // for (var i = 0; i < positions.count; i++) {
  //   v3.fromBufferAttribute(positions, i).setLength(k);
  //   let n = noise.perlin3(v3.x, v3.y, v3.z);
  //   v3.setLength(1 + 0.3 * n);
  //   positions.setXYZ(i, v3.x, v3.y, v3.z);
  // }

  for (var i = 0; i < positions.count; i++) {
    // positions.setXYZ(i, v3.x, v3.y, v3.z);
    p.fromBufferAttribute(positions, i) //.setLength(k);
    p.normalize().multiplyScalar(
      1 + 0.3 * noise.perlin3(p.x * k + time, p.y * k, p.z * k)
    )
    positions.setXYZ(i, p.x, p.y, p.z);
  }
  positions.needsUpdate = true;
  sphere2.geometry.computeVertexNormals(); // don't forget to call this
  
  
};
var update3 = function () {

  var time = performance.now() * 0.00027;
  var k = 1.06;

  var p = new THREE.Vector3();   
  const positions = sphere3.geometry.attributes.position;

  for (var i = 0; i < positions.count; i++) {
    // positions.setXYZ(i, v3.x, v3.y, v3.z);
    p.fromBufferAttribute(positions, i) //.setLength(k);
    p.normalize().multiplyScalar(
      1 + 0.4 * noise.perlin3(p.x * k + time, p.y * k, p.z * k)
    )
    positions.setXYZ(i, p.x, p.y, p.z);
  }
  positions.needsUpdate = true;
  sphere3.geometry.computeVertexNormals(); // don't forget to call this
  
  
};

function animate() {
  // sphere.rotation.x += 0.0001;
  // sphere.rotation.y += 0.0001;

  update();
  update2();
  update3();
  /* render scene and camera */
  renderer.render(scene, camera);
  requestAnimationFrame(animate);
}

const resize = () => {
  renderer.setSize(window.innerWidth, window.innerHeight)
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
};

export const createScene = (el) => {
  renderer = new THREE.WebGLRenderer({ antialias: true, canvas: el });
  // renderer.setClearColor(0xffffff);
  renderer.setClearColor(0xfafafa);
  //  use device aspect ratio //
  renderer.setPixelRatio(window.devicePixelRatio);
  // set size of canvas within window //
  renderer.setSize(window.innerWidth, window.innerHeight);
  resize();
  animate();
}

window.addEventListener('resize', resize);

// requestAnimationFrame(animate);
export {
animate
}
